export default __webpack_public_path__ + "static/media/Hub.256.43e8b271.png";